module.exports = __webpack_public_path__ + "img/tulip.be5030ca.webp";